import { defineMessages } from 'react-intl';

export default defineMessages({
  clientsEmptyState: {
    defaultMessage: 'No se encontraron clientes',
    id: 'K6Vxz6',
  },
});
